module.exports = __webpack_public_path__ + "img/NoData.982fd0c6.png";